import React, { FC } from 'react';
import Section from 'evcharging/containers/layout/Section';
import Container from 'evcharging/components/Container';
import Title from 'evcharging/components/Title';
import Spacer from 'evcharging/components/Spacer';
import FaqItem, { FaqItemProps } from 'evcharging/containers/layout/FaqItem';
import useI18n from 'evcharging/hooks/useI18n';

interface FaqSectionProps {
  faqs: FaqItemProps[];
}

const FaqSection: FC<FaqSectionProps> = (props) => {
  const { faqs } = props;
  const { t } = useI18n();

  if (!faqs.length) {
    return null;
  }

  return (
    <Section background={'middle'} padding={'74px 0'}>
      <Container>
        <Title variant={'p'} center fontWeight={400}>
          {t('faq.title')}
        </Title>
        <Spacer value={36} />
        {faqs.map((faq) => (
          <FaqItem {...faq} key={faq.question} />
        ))}
      </Container>
    </Section>
  );
};

export default FaqSection;
